/* ezink-htv-price.js — quote decoration from print size (pdp-v8) */
(function (w) {
  var SIZES = [{"id":"XS","w":1.5,"h":1.5,"tiers":[[10,730],[20,608],[50,362],[100,244],[200,194],[300,154],[500,140],[1000,126],[2500,120],[5000,116]]},{"id":"SM","w":2.5,"h":2.5,"tiers":[[10,822],[20,686],[50,452],[100,312],[200,260],[300,216],[500,202],[1000,186],[2500,178],[5000,170]]},{"id":"LC","w":4.0,"h":4.0,"tiers":[[10,900],[20,752],[50,544],[100,400],[200,350],[300,310],[500,290],[1000,276],[2500,266],[5000,260]]},{"id":"A5","w":5.8,"h":8.3,"tiers":[[10,1194],[20,998],[50,710],[100,490],[200,414],[300,372],[500,344],[1000,316],[2500,300],[5000,284]]},{"id":"A5L","w":11.7,"h":4.25,"tiers":[[10,1194],[20,998],[50,710],[100,490],[200,414],[300,372],[500,344],[1000,316],[2500,300],[5000,284]]},{"id":"A4","w":8.3,"h":11.7,"tiers":[[10,1430],[20,1188],[50,918],[100,634],[200,520],[300,476],[500,448],[1000,420],[2500,404],[5000,388]]},{"id":"A4L","w":16.5,"h":5.85,"tiers":[[10,1430],[20,1188],[50,918],[100,634],[200,520],[300,476],[500,448],[1000,420],[2500,404],[5000,388]]},{"id":"SQ","w":11.7,"h":11.7,"tiers":[[10,1792],[20,1494],[50,1182],[100,820],[200,680],[300,626],[500,590],[1000,564],[2500,544],[5000,532]]},{"id":"A3","w":11.7,"h":16.5,"tiers":[[10,2156],[20,1798],[50,1448],[100,1010],[200,840],[300,772],[500,734],[1000,702],[2500,688],[5000,674]]}];
  var VARIANTS = {};
  var ONE_COLOR_MULT = 0.88;
  var ONE_COLOR_FAMILIES = { WE: 1, LM: 1, BL: 1, SB: 1, LB: 1, HW: 1, PR: 1 };
  var BASE_TYPES = [
    { id: "WE", label: "Wearable", hint: "Cotton, poly-cotton, and non-sublimated polyester. Full color.", mult: 1, minQty: 10 },
    { id: "DF", label: "DTF", hint: "For transfer jobs under 10 pieces, DTF may be used.", mult: 0.95, minQty: 1 },
    { id: "LM", label: "LoMelt", hint: "Heat-sensitive and performance fabrics.", mult: 1.08, minQty: 10 },
    { id: "BL", label: "Blocker", hint: "Sublimated or dye-migrating polyester.", mult: 1.18, minQty: 10 },
    { id: "SB", label: "Soft Shell Blocker", hint: "Softshell jackets and similar fabrics.", mult: 1.18, minQty: 10 },
    { id: "LB", label: "LoMelt Blocker", hint: "Heat-sensitive fabrics that may bleed.", mult: 1.18, minQty: 10 },
    { id: "HW", label: "Headwear", hint: "Caps and structured hats.", mult: 1.12, minQty: 10 },
    { id: "SR", label: "Reflective", hint: "High-visibility and night safety prints.", mult: 1.3, minQty: 10 },
    { id: "PR", label: "Promo", hint: "Bags, umbrellas, and coated promo items.", mult: 1, minQty: 10 },
    { id: "NE", label: "Neon", hint: "Fluorescent colors. 20-piece minimum.", mult: 1.22, minQty: 20 },
    { id: "NB", label: "Neon Blocker", hint: "Neon on fabrics that may bleed. 20-piece minimum.", mult: 1.4, minQty: 20 }
  ];
  function buildTypes() {
    var out = [];
    for (var i = 0; i < BASE_TYPES.length; i++) {
      var t = BASE_TYPES[i];
      if (ONE_COLOR_FAMILIES[t.id]) {
        out.push({
          id: t.id + "1",
          label: t.label + " 1 Color",
          hint: "One solid color. Default at 10+ pieces.",
          mult: Math.round(t.mult * ONE_COLOR_MULT * 1000) / 1000,
          minQty: t.minQty,
          parent: t.id
        });
      }
      out.push(t);
    }
    return out;
  }
  var TYPES = buildTypes();
  var MIN_TRANSFER_QTY = 10;

  function typeInfo(id) {
    if (id === "1C") id = "WE1";
    id = id || "WE1";
    var wearable = TYPES[0];
    for (var i = 0; i < TYPES.length; i++) {
      if (TYPES[i].id === id) return TYPES[i];
      if (TYPES[i].id === "WE") wearable = TYPES[i];
    }
    return wearable;
  }

  function hasType(id) {
    for (var i = 0; i < TYPES.length; i++) {
      if (TYPES[i].id === id) return true;
    }
    return false;
  }

  function expandOneColorIds(ids) {
    var out = [];
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i];
      if (hasType(id + "1")) out.push(id + "1");
      out.push(id);
    }
    return out;
  }

  function productBlob(src) {
    if (!src) return "";
    if (typeof src === "string") return src.toLowerCase();
    if (typeof src.getAttribute === "function") {
      return [
        src.getAttribute("data-ezink-tags") || "",
        src.getAttribute("data-ezink-type") || "",
        src.getAttribute("data-ezink-title") || "",
        src.getAttribute("data-ezink-handle") || ""
      ].join(" ").toLowerCase();
    }
    return [src.tags, src.type, src.title, src.handle, src.blob].join(" ").toLowerCase();
  }

  // Polyester as the fabric, not a cotton/poly or tri-blend. material:polyester is that tag.
  function highPolyester(src) {
    var blob = productBlob(src);
    if (/(^|[\s,])material:polyester([\s,]|$)/.test(blob)) return true;
    if (/\b100\s*%\s*(recycled\s+)?polyester\b/.test(blob)) return true;
    if (!/\bpolyester\b/.test(blob)) return false;
    if (
      /material:cotton-poly/.test(blob) ||
      /material:tri-blend/.test(blob) ||
      /(^|[\s,])material:cotton([\s,]|$)/.test(blob)
    ) {
      return false;
    }
    if (/cotton[\s/-]*poly/.test(blob) || /poly[\s/-]*cotton/.test(blob) || /tri-?blend/.test(blob)) {
      return false;
    }
    return true;
  }

  function productKind(src) {
    var blob = productBlob(src);
    if (
      /headwear/.test(blob) ||
      /category:(hat|beanie|visor|bucket)/.test(blob) ||
      /garment:(hat|trucker|snapback|dad-hat|beanie|visor|bucket)/.test(blob) ||
      /\b(hats?|caps?|beanie|visor|snapback|trucker|dad-hats?|bucket-hat)\b/.test(blob)
    ) {
      return "headwear";
    }
    if (/soft[\s-]?shell/.test(blob)) return "softshell";
    if (
      /accessories/.test(blob) ||
      /category:(bag|apron|towel|blanket)/.test(blob) ||
      /\b(bags?|totes?|aprons?|towels?|blankets?)\b/.test(blob)
    ) {
      return "accessory";
    }
    if (
      /performance/.test(blob) ||
      /dri-?fit/.test(blob) ||
      /moisture[\s-]?wick/.test(blob) ||
      /sublimat/.test(blob) ||
      highPolyester(blob) ||
      /\bnylon\b/.test(blob)
    ) {
      return "performance";
    }
    return "garment";
  }

  function availableTypeIds(src, qty) {
    qty = parseInt(qty, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    var kind = productKind(src);
    var ids;
    if (qty < MIN_TRANSFER_QTY) {
      ids = ["DF"];
    } else if (kind === "headwear") {
      ids = ["HW"];
    } else if (kind === "softshell") {
      ids = ["SB"];
    } else if (kind === "performance") {
      ids = ["WE", "DF", "LM", "BL", "LB", "SR"];
      if (qty >= 20) ids.push("NB");
    } else if (kind === "accessory") {
      ids = ["WE", "DF", "PR"];
    } else {
      ids = ["WE", "DF", "LM", "BL", "SR"];
      if (qty >= 20) ids.push("NE");
    }
    ids = expandOneColorIds(ids);
    return ids.filter(function (id) {
      var t = typeInfo(id);
      var min = t.minQty == null ? 1 : t.minQty;
      // An empty size grid is qty 0. Keep DTF listed until a quantity is entered.
      if (qty < 1 && id === "DF") return true;
      return qty >= min;
    });
  }

  function availableTypes(src, qty) {
    var ids = availableTypeIds(src, qty);
    return TYPES.filter(function (t) { return ids.indexOf(t.id) !== -1; });
  }

  function inkChroma(r, g, b) {
    return Math.max(r, g, b) - Math.min(r, g, b);
  }

  function inkLum(r, g, b) {
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }

  function inkHue(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var d = max - min;
    if (d < 1e-6) return 0;
    var h;
    if (max === r) h = ((g - b) / d) % 6;
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60;
    if (h < 0) h += 360;
    return h;
  }

  function mergeHueBins(bins) {
    var guard = 0;
    while (guard++ < 24) {
      var moved = false;
      for (var i = 0; i < 24; i++) {
        if (!bins[i]) continue;
        var li = (i + 23) % 24;
        var ri = (i + 1) % 24;
        var left = bins[li];
        var right = bins[ri];
        var bigger = left >= right ? left : right;
        var bi = left >= right ? li : ri;
        if (bigger > bins[i] && bins[i] < bigger * 0.15) {
          bins[bi] += bins[i];
          bins[i] = 0;
          moved = true;
        }
      }
      if (!moved) break;
    }
  }

  function hueFamilyCount(bins, minCount) {
    var on = [];
    var any = false;
    var i;
    for (i = 0; i < 24; i++) {
      on[i] = bins[i] >= minCount;
      if (on[i]) any = true;
    }
    if (!any) return 0;
    var off = 0;
    while (off < 24 && on[off]) off++;
    if (off === 24) return 99;
    var idx = (off + 1) % 24;
    var seen = 0;
    var span = 0;
    var families = 0;
    while (seen < 24) {
      if (on[idx]) span++;
      else if (span) {
        families += span > 4 ? 99 : 1;
        span = 0;
      }
      idx = (idx + 1) % 24;
      seen++;
    }
    if (span) families += span > 4 ? 99 : 1;
    return families;
  }

  // "one" is a single ink. "multi" is two or more inks, a wide gradient, or a photo.
  // Opaque JPEG and PDF pages treat near-white as paper. Transparent pixels are not ink.
  // A light fringe with partial alpha is an edge blend, not a second ink.
  function classifyInk(data, width, height) {
    width = width | 0;
    height = height | 0;
    if (!data || width < 2 || height < 2) return null;
    if (data.length < width * height * 4) return null;
    var longEdge = Math.max(width, height);
    var step = longEdge > 160 ? Math.ceil(longEdge / 160) : 1;
    var total = 0;
    var clear = 0;
    var pixels = [];
    var y, x, i, a, r, g, b, chroma, lum;
    for (y = 0; y < height; y += step) {
      for (x = 0; x < width; x += step) {
        i = (y * width + x) * 4;
        a = data[i + 3];
        total++;
        if (a < 40) {
          clear++;
          continue;
        }
        r = data[i];
        g = data[i + 1];
        b = data[i + 2];
        chroma = inkChroma(r, g, b);
        lum = inkLum(r, g, b);
        if (a < 220 && chroma <= 18 && lum >= 200) continue;
        pixels.push(r, g, b);
      }
    }
    if (total < 16 || !pixels.length) return null;
    var opaque = clear / total < 0.03;
    var ink = [];
    if (opaque) {
      for (i = 0; i < pixels.length; i += 3) {
        chroma = inkChroma(pixels[i], pixels[i + 1], pixels[i + 2]);
        lum = inkLum(pixels[i], pixels[i + 1], pixels[i + 2]);
        if (chroma <= 18 && lum >= 210) continue;
        ink.push(pixels[i], pixels[i + 1], pixels[i + 2]);
      }
    } else {
      ink = pixels;
    }
    if (ink.length < 24) return null;
    var gray = 0;
    var bins = [];
    for (i = 0; i < 24; i++) bins[i] = 0;
    for (i = 0; i < ink.length; i += 3) {
      r = ink[i];
      g = ink[i + 1];
      b = ink[i + 2];
      if (inkChroma(r, g, b) < 18) {
        gray++;
        continue;
      }
      bins[Math.floor(inkHue(r, g, b) / 15) % 24]++;
    }
    mergeHueBins(bins);
    var minCount = Math.max(4, Math.round((ink.length / 3) * 0.05));
    var families = hueFamilyCount(bins, minCount);
    var inks = families + (gray >= minCount ? 1 : 0);
    if (inks >= 2) return "multi";
    if (inks === 1) return "one";
    return null;
  }

  function preferredTypeId(available, currentId, opts) {
    opts = opts || {};
    var ids = [];
    for (var i = 0; i < (available || []).length; i++) {
      ids.push(available[i].id || available[i]);
    }
    if (!ids.length) return "DF";
    if (ids.length === 1) return ids[0];
    if (currentId === "1C") currentId = "WE1";
    var keep = currentId && ids.indexOf(currentId) !== -1;
    if (keep && !opts.forced) return currentId;
    var kind = opts.kind || (opts.src != null ? productKind(opts.src) : "");
    var poly = opts.src != null && highPolyester(opts.src);
    var prefer = ["WE1", "HW1", "SB1", "PR1", "LM1", "WE", "HW", "SB", "PR", "LM", "DF"];
    if (kind === "accessory") prefer = ["PR1", "PR", "WE1", "WE", "DF"];
    if (kind === "performance") prefer = ["LM1", "LB1", "BL1", "WE1", "LM", "LB", "BL", "WE", "DF"];
    if (poly && kind !== "headwear" && kind !== "accessory" && kind !== "softshell") {
      prefer = ["BL1", "LB1", "LM1", "WE1", "BL", "LB", "LM", "WE", "DF"];
    }
    if (kind === "headwear") prefer = ["HW1", "HW", "DF"];
    if (kind === "softshell") prefer = ["SB1", "SB", "DF"];
    // Uploaded art with more than one ink uses the full-color film. Under 10 the only id is DF.
    if (opts.colors === "multi") {
      var full = [];
      for (var f = 0; f < prefer.length; f++) {
        if (prefer[f].slice(-1) !== "1") full.push(prefer[f]);
      }
      prefer = full;
    }
    for (var p = 0; p < prefer.length; p++) {
      if (ids.indexOf(prefer[p]) !== -1) return prefer[p];
    }
    return ids[0];
  }

  function availabilityNote(src, qty) {
    qty = parseInt(qty, 10) || 0;
    if (qty < MIN_TRANSFER_QTY) return "For transfer jobs under 10 pieces, DTF may be used.";
    var kind = productKind(src);
    if (kind === "headwear") return "This product uses Headwear transfers.";
    if (kind === "softshell") return "Softshell uses Soft Shell Blocker.";
    if (kind === "accessory") return "Bags and promo items use Promo transfers.";
    if (highPolyester(src)) return "Polyester apparel uses Blocker.";
    return "";
  }
  function typeMult(id) {
    return typeInfo(id).mult || 1;
  }

  function pickSize(w, h) {
    w = Number(w) || 0;
    h = Number(h) || 0;
    var need = [w, h].sort(function (a, b) { return a - b; });
    var fits = [];
    for (var i = 0; i < SIZES.length; i++) {
      var s = SIZES[i];
      var dims = [s.w, s.h].sort(function (a, b) { return a - b; });
      if (dims[0] + 0.05 >= need[0] && dims[1] + 0.05 >= need[1]) fits.push(s);
    }
    if (fits.length) {
      return fits.reduce(function (a, b) { return a.w * a.h <= b.w * b.h ? a : b; });
    }
    return SIZES.reduce(function (a, b) { return a.w * a.h >= b.w * b.h ? a : b; });
  }

  function bandCents(size, qty) {
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var tiers = size.tiers || [];
    var chosen = tiers[0];
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i][0]) chosen = tiers[i];
    }
    return chosen ? chosen[1] : 0;
  }

  function bandMin(size, qty) {
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var tiers = size.tiers || [];
    var chosen = tiers[0];
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i][0]) chosen = tiers[i];
    }
    return chosen ? chosen[0] : 20;
  }

  function sellCents(w, h, qty) {
    var size = pickSize(w, h);
    if (!size) return 0;
    var cents = bandCents(size, qty);
    var need = (Number(w) || 0) * (Number(h) || 0);
    var area = size.w * size.h;
    if (area > 0 && need > area + 0.05) cents = Math.round(cents * need / area);
    return cents;
  }

  function isApparelPdp(pdp) {
    if (!pdp) return false;
    var blob = ((pdp.getAttribute("data-ezink-tags") || "") + " " + (pdp.getAttribute("data-ezink-type") || "")).toLowerCase();
    return blob.indexOf("blanks") !== -1 || blob.indexOf("apparel") !== -1;
  }

  function smallestSize() {
    var xs = SIZES[0];
    for (var i = 1; i < SIZES.length; i++) {
      if (SIZES[i].w * SIZES[i].h < xs.w * xs.h) xs = SIZES[i];
    }
    return xs;
  }

  function startingDecoCents() {
    var size = smallestSize();
    if (!size) return 0;
    return Math.round(sellCents(size.w, size.h, 1000) * typeMult("WE1"));
  }

  var TIER_QTYS = [10, 20, 50, 100, 200, 300, 500, 1000, 2500, 5000];
  var BLANK_LIST_MULT = 1.5;
  var BLANK_MULT = 1.0;
  var BLANK_MULT_TIERS = [
    [1, 1.5],
    [10, 1.5],
    [20, 1.45],
    [50, 1.4],
    [100, 1.35],
    [200, 1.3],
    [300, 1.25],
    [500, 1.22],
    [1000, 1.2]
  ];

  function productSrc(src) {
    if (src && typeof src.getAttribute === "function") {
      if (src.getAttribute("data-ezink-tags") || src.getAttribute("data-ezink-type")) return src;
      var nested = src.querySelector && src.querySelector("[data-ezink-art-pdp], [data-ezink-tags]");
      if (nested) return nested;
    }
    if (typeof document !== "undefined" && document.querySelector) {
      var art = document.querySelector("[data-ezink-art-pdp]");
      if (art) return art;
    }
    return src;
  }

  function isTee(src) {
    var blob = productBlob(productSrc(src));
    if (!blob) return true;
    return /category:t-shirt/.test(blob) || /garment:tee\b/.test(blob);
  }

  var FLAT_BLANK_STYLES = { BM6624: 1, BW6620: 1 };

  function productStyle(src) {
    var blob = productBlob(productSrc(src));
    var m = blob.match(/style:([a-z0-9_-]+)/i);
    return m ? m[1].toUpperCase() : "";
  }

  function usesFlatBlank(src) {
    if (isTee(src)) return true;
    return !!FLAT_BLANK_STYLES[productStyle(src)];
  }

  function blankMult(qty, src) {
    if (usesFlatBlank(src)) return BLANK_MULT;
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var chosen = BLANK_MULT_TIERS[0][1];
    for (var i = 0; i < BLANK_MULT_TIERS.length; i++) {
      if (qty >= BLANK_MULT_TIERS[i][0]) chosen = BLANK_MULT_TIERS[i][1];
    }
    return chosen;
  }

  function garmentCents(listCents, qty, src) {
    listCents = Math.max(0, parseInt(listCents, 10) || 0);
    return Math.round(listCents * blankMult(qty, src) / BLANK_LIST_MULT); // blanks only, never transfers
  }

  var LOW_QTY = 10;
  var LOW_QTY_FEE_CENTS = 500;

  function lowQtyFeeCents(qty) {
    qty = parseInt(qty, 10) || 0;
    if (qty < 1 || qty >= LOW_QTY) return 0;
    return LOW_QTY_FEE_CENTS;
  }

  function estimateDecoCents(qty, pdp) {
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var art = 0;
    try { art = extraEachCents(qty, pdp) || 0; } catch (eArt) {}
    if (art > 0) return art;
    var size = smallestSize();
    if (!size) return 0;
    var id = qty < MIN_TRANSFER_QTY ? "DF" : "WE1";
    return Math.round(sellCents(size.w, size.h, qty) * typeMult(id));
  }

  function estimateTiers(garmentListCents, pdp) {
    garmentListCents = Math.max(0, parseInt(garmentListCents, 10) || 0);
    return TIER_QTYS.map(function (qty) {
      var deco = estimateDecoCents(qty, pdp);
      var garment = garmentCents(garmentListCents, qty, pdp);
      var fee = lowQtyFeeCents(qty);
      var total = garment * qty + deco * qty + fee;
      var each = Math.round(total / qty);
      return { qty: qty, deco: deco, garment: garment, fee: fee, each: each, total: total };
    });
  }

  var PACK_GUTTER = 0.25;
  var PLACEMENT_FEE_CENTS = 100;
  var PACK_INF = 1e15;

  function typeParent(id) {
    var t = typeInfo(id);
    return t.parent || t.id || "WE";
  }

  function permuteList(arr) {
    if (arr.length <= 1) return [arr.slice()];
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var rest = arr.slice(0, i).concat(arr.slice(i + 1));
      var sub = permuteList(rest);
      for (var j = 0; j < sub.length; j++) out.push([arr[i]].concat(sub[j]));
    }
    return out;
  }

  function shelfPack(boxes, W, H, g) {
    var list = boxes.slice().sort(function (a, b) { return b.h - a.h; });
    var x = 0;
    var y = 0;
    var shelfH = 0;
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (x > 0 && x + g + b.w > W + 0.05) {
        y += shelfH + g;
        x = 0;
        shelfH = 0;
      }
      if (b.w > W + 0.05 || y + b.h > H + 0.05) return false;
      x = x === 0 ? b.w : x + g + b.w;
      if (b.h > shelfH) shelfH = b.h;
    }
    return y + shelfH <= H + 0.05;
  }

  function canPackTwo(a, b, W, H, g) {
    var ao = [[a.w, a.h], [a.h, a.w]];
    var bo = [[b.w, b.h], [b.h, b.w]];
    var sheets = [[W, H], [H, W]];
    for (var s = 0; s < 2; s++) {
      var sw = sheets[s][0];
      var sh = sheets[s][1];
      for (var i = 0; i < 2; i++) {
        for (var j = 0; j < 2; j++) {
          var aw = ao[i][0];
          var ah = ao[i][1];
          var bw = bo[j][0];
          var bh = bo[j][1];
          if (aw + g + bw <= sw + 0.05 && Math.max(ah, bh) <= sh + 0.05) return true;
          if (Math.max(aw, bw) <= sw + 0.05 && ah + g + bh <= sh + 0.05) return true;
        }
      }
    }
    return false;
  }

  function canPackRects(rects, W, H) {
    var g = PACK_GUTTER;
    var n = (rects || []).length;
    if (!n) return true;
    if (n === 1) {
      var r = rects[0];
      return (r.w <= W + 0.05 && r.h <= H + 0.05) || (r.h <= W + 0.05 && r.w <= H + 0.05);
    }
    if (n === 2) return canPackTwo(rects[0], rects[1], W, H, g);
    var maxRot = 1 << n;
    var perms = permuteList(rects);
    for (var p = 0; p < perms.length; p++) {
      for (var rot = 0; rot < maxRot; rot++) {
        var boxes = [];
        for (var i = 0; i < n; i++) {
          var item = perms[p][i];
          boxes.push(rot & (1 << i) ? { w: item.h, h: item.w } : { w: item.w, h: item.h });
        }
        if (shelfPack(boxes, W, H, g) || shelfPack(boxes, H, W, g)) return true;
      }
    }
    return false;
  }

  function smallestSheetForRects(rects) {
    var ordered = SIZES.slice().sort(function (a, b) { return a.w * a.h - b.w * b.h; });
    for (var i = 0; i < ordered.length; i++) {
      var s = ordered[i];
      if (canPackRects(rects, s.w, s.h)) return s;
    }
    return null;
  }

  function collectSpecs(pdp) {
    var specs = [];
    if (Array.isArray(pdp)) {
      pdp.forEach(function (it) {
        var w = it.w != null ? it.w : (it.size && it.size.w);
        var h = it.h != null ? it.h : (it.size && it.size.h);
        var type = it.type || (it.transfer && it.transfer.id);
        if (w > 0 && h > 0) {
          specs.push({
            w: Number(w),
            h: Number(h),
            type: type,
            label: it.label || "",
            sizeLabel: (it.size && it.size.label) || ""
          });
        }
      });
      return specs;
    }
    pdp = pdp || document.querySelector("[data-ezink-art-pdp][data-ezink-art-mode='apparel']") || document.querySelector("[data-ezink-art-pdp]");
    if (!isApparelPdp(pdp) || !w.EZINKArtItems) return specs;
    w.EZINKArtItems.list(pdp).forEach(function (it) {
      if (!it.size) return;
      specs.push({
        w: Number(it.size.w) || 0,
        h: Number(it.size.h) || 0,
        type: it.transfer && it.transfer.id,
        label: it.label || "",
        sizeLabel: it.size.label || ""
      });
    });
    return specs.filter(function (s) { return s.w > 0 && s.h > 0; });
  }

  function specMult(spec) {
    return typeMult(spec && spec.type ? spec.type : "WE1");
  }

  function maskMult(specs, mask) {
    var m = 0;
    for (var i = 0; i < specs.length; i++) {
      if (mask & (1 << i)) m = Math.max(m, specMult(specs[i]));
    }
    return m || 1;
  }

  function packGroupPlan(specs, qty) {
    var n = specs.length;
    if (!n) return { cents: 0, sheets: [] };
    if (n === 1) {
      var one = pickSize(specs[0].w, specs[0].h);
      return {
        cents: Math.round(sellCents(specs[0].w, specs[0].h, qty) * specMult(specs[0])),
        sheets: [{ size: one, indexes: [0], specs: [specs[0]] }]
      };
    }
    var full = (1 << n) - 1;
    var oneCost = new Array(full + 1);
    var oneSheet = new Array(full + 1);
    var mask;
    for (mask = 1; mask <= full; mask++) {
      var rects = [];
      var mlt = maskMult(specs, mask);
      for (var i = 0; i < n; i++) {
        if (mask & (1 << i)) rects.push({ w: specs[i].w, h: specs[i].h });
      }
      if (rects.length === 1) {
        oneSheet[mask] = pickSize(rects[0].w, rects[0].h);
        oneCost[mask] = Math.round(sellCents(rects[0].w, rects[0].h, qty) * mlt);
      } else {
        var sheet = smallestSheetForRects(rects);
        oneSheet[mask] = sheet;
        oneCost[mask] = sheet ? Math.round(bandCents(sheet, qty) * mlt) : PACK_INF;
      }
    }
    var best = new Array(full + 1);
    var choice = new Array(full + 1);
    best[0] = 0;
    for (mask = 1; mask <= full; mask++) {
      best[mask] = oneCost[mask];
      choice[mask] = 0;
      for (var sub = (mask - 1) & mask; sub > 0; sub = (sub - 1) & mask) {
        var c = best[sub] + best[mask ^ sub];
        if (c < best[mask]) {
          best[mask] = c;
          choice[mask] = sub;
        }
      }
    }
    var sheets = [];
    function walk(m) {
      if (!m) return;
      if (!choice[m]) {
        var ix = [];
        var sp = [];
        for (var k = 0; k < n; k++) {
          if (m & (1 << k)) {
            ix.push(k);
            sp.push(specs[k]);
          }
        }
        sheets.push({ size: oneSheet[m], indexes: ix, specs: sp });
        return;
      }
      walk(choice[m]);
      walk(m ^ choice[m]);
    }
    walk(full);
    return { cents: best[full], sheets: sheets };
  }

  function ownLocationCents(spec, qty) {
    return Math.round(sellCents(spec.w, spec.h, qty) * specMult(spec));
  }

  function packDecorationPlan(qty, specs) {
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var groups = {};
    (specs || []).forEach(function (s) {
      var id = s.type || "WE1";
      var fam = typeParent(id);
      if (!groups[fam]) groups[fam] = { specs: [] };
      groups[fam].specs.push(s);
    });
    var sheets = [];
    var internalCents = 0;
    Object.keys(groups).forEach(function (fam) {
      var plan = packGroupPlan(groups[fam].specs, qty);
      internalCents += plan.cents;
      plan.sheets.forEach(function (sh) { sheets.push(sh); });
    });
    var n = (specs || []).length;
    var cents = 0;
    (specs || []).forEach(function (s) { cents += ownLocationCents(s, qty); });
    if (n > 1 && PLACEMENT_FEE_CENTS > 0) cents += PLACEMENT_FEE_CENTS * (n - 1);
    return {
      cents: Math.round(cents),
      internalCents: Math.round(internalCents),
      sheets: sheets,
      count: n
    };
  }

  function packDecorationCents(qty, specs) {
    if (!specs || !specs.length) return 0;
    return packDecorationPlan(qty, specs).cents;
  }

  function extraEachCents(qty, pdp) {
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var specs = collectSpecs(pdp);
    if (!specs.length) return 0;
    return packDecorationCents(qty, specs);
  }

  function sizePrintLabel(size) {
    if (!size) return "";
    var names = { A5L: "A5 Long", A4L: "A4 Long" };
    var name = names[size.id] || size.id;
    var inch = function (n) { return Math.round(n) === n ? String(Math.round(n)) : String(n); };
    return name + " — " + inch(size.w) + " × " + inch(size.h) + " in";
  }

  function cartLines(qty, pdp) {
    if (!Array.isArray(pdp) && !isApparelPdp(pdp)) return [];
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var specs = collectSpecs(pdp);
    if (!specs.length) return [];
    var plan = packDecorationPlan(qty, specs);
    var out = [];
    specs.forEach(function (spec) {
      var size = pickSize(spec.w, spec.h);
      if (!size) return;
      var band = bandMin(size, qty);
      var vid = VARIANTS[size.id + "|" + band];
      if (!vid) return;
      var place = spec.label || "Artwork";
      var sizeText = spec.sizeLabel || sizePrintLabel(size);
      var typeText = typeInfo(spec.type || "WE1").label || "Wearable 1 Color";
      out.push({
        id: vid,
        quantity: qty,
        properties: {
          _Location: place,
          "_Print size": sizeText,
          "_Print type": typeText,
          _Decoration: place + " " + sizeText,
          Print: [place, sizeText, typeText].filter(Boolean).join(" · ")
        }
      });
    });
    if (plan.count > 1 && PLACEMENT_FEE_CENTS > 0 && VARIANTS["FEE|1"]) {
      out.push({
        id: VARIANTS["FEE|1"],
        quantity: qty * (plan.count - 1),
        properties: {
          _Location: "Extra placement",
          _Decoration: "$" + (PLACEMENT_FEE_CENTS / 100).toFixed(2) + " each after the first location",
          Print: "Extra location"
        }
      });
    }
    return out;
  }

  var api = {
    types: TYPES,
    minQty: MIN_TRANSFER_QTY,
    typeInfo: typeInfo,
    productKind: productKind,
    highPolyester: highPolyester,
    availableTypeIds: availableTypeIds,
    availableTypes: availableTypes,
    preferredTypeId: preferredTypeId,
    classifyInk: classifyInk,
    availabilityNote: availabilityNote,
    sizes: SIZES,
    pickSize: pickSize,
    sellCents: sellCents,
    startingDecoCents: startingDecoCents,
    estimateDecoCents: estimateDecoCents,
    estimateTiers: estimateTiers,
    tierQtys: TIER_QTYS,
    blankListMult: BLANK_LIST_MULT,
    blankMult: blankMult,
    blankMultTiers: BLANK_MULT_TIERS,
    isTee: isTee,
    usesFlatBlank: usesFlatBlank,
    productStyle: productStyle,
    flatBlankStyles: FLAT_BLANK_STYLES,
    garmentCents: garmentCents,
    lowQtyFeeCents: lowQtyFeeCents,
    lowQtyFee: LOW_QTY_FEE_CENTS,
    extraEachCents: extraEachCents,
    packGutter: PACK_GUTTER,
    placementFeeCents: PLACEMENT_FEE_CENTS,
    canPackRects: canPackRects,
    smallestSheetForRects: smallestSheetForRects,
    packDecorationCents: packDecorationCents,
    packDecorationPlan: packDecorationPlan,
    cartLines: cartLines,
    setVariants: function (map) { VARIANTS = map || {}; }
  };
  w.EZINKHtv = api;
  if (typeof module !== "undefined" && module.exports) module.exports = api;
})(typeof window !== "undefined" ? window : {});
if (typeof window !== "undefined" && window.EZINKHtv) window.EZINKHtv.setVariants({"XS|10":51261821321383,"XS|20":51259272855719,"XS|50":51259272888487,"XS|100":51259272921255,"XS|200":51261821354151,"XS|300":51261821386919,"XS|500":51259272986791,"XS|1000":51261821419687,"XS|2500":51261821452455,"XS|5000":51261821485223,"SM|10":51261821517991,"SM|20":51259273019559,"SM|50":51259273052327,"SM|100":51259273085095,"SM|200":51261821550759,"SM|300":51261821583527,"SM|500":51259273150631,"SM|1000":51261821616295,"SM|2500":51261821649063,"SM|5000":51261821681831,"LC|10":51261821714599,"LC|20":51259273183399,"LC|50":51259273216167,"LC|100":51259273248935,"LC|200":51261821747367,"LC|300":51261821780135,"LC|500":51259273314471,"LC|1000":51261821812903,"LC|2500":51261821845671,"LC|5000":51261821878439,"A5|10":51261821911207,"A5|20":51259273347239,"A5|50":51259273380007,"A5|100":51259273412775,"A5|200":51261821943975,"A5|300":51261821976743,"A5|500":51259273478311,"A5|1000":51261822009511,"A5|2500":51261822042279,"A5|5000":51261822075047,"A5L|10":51261822107815,"A5L|20":51259273511079,"A5L|50":51259273543847,"A5L|100":51259273576615,"A5L|200":51261822140583,"A5L|300":51261822173351,"A5L|500":51259273642151,"A5L|1000":51261822206119,"A5L|2500":51261822238887,"A5L|5000":51261822271655,"A4|10":51261822304423,"A4|20":51259273674919,"A4|50":51259273707687,"A4|100":51259273740455,"A4|200":51261822337191,"A4|300":51261822369959,"A4|500":51259273805991,"A4|1000":51261822402727,"A4|2500":51261822435495,"A4|5000":51261822468263,"A4L|10":51261822501031,"A4L|20":51259273838759,"A4L|50":51259273871527,"A4L|100":51259273904295,"A4L|200":51261822533799,"A4L|300":51261822566567,"A4L|500":51259273969831,"A4L|1000":51261822599335,"A4L|2500":51261822632103,"A4L|5000":51261822664871,"SQ|10":51261822697639,"SQ|20":51259274002599,"SQ|50":51259274035367,"SQ|100":51259274068135,"SQ|200":51261822730407,"SQ|300":51261822763175,"SQ|500":51259274133671,"SQ|1000":51261822795943,"SQ|2500":51261822828711,"SQ|5000":51261822861479,"A3|10":51261822894247,"A3|20":51259274166439,"A3|50":51259274199207,"A3|100":51259274231975,"A3|200":51261822927015,"A3|300":51261822959783,"A3|500":51259274297511,"A3|1000":51261822992551,"A3|2500":51261823025319,"A3|5000":51261823058087,"FEE|1":51259314929831});
